// extracted by mini-css-extract-plugin
module.exports =  {"alert":"VcLI1ujakPbAY6d9HO8n"};